// <input
//    data-controller="datepicker"
// >
import DateTimePickerController from 'controllers/datetimepicker_controller';

export default class extends DateTimePickerController {
  get options() {
    return {
      format: 'LT',
      useCurrent: false,
      timeZone: 'Pacific Time (US & Canada)',
      icons: {
        time: 'fa-regular fa-clock',
        date: 'fa-regular fa-calendar',
        up: 'fa-regular fa-chevron-up',
        down: 'fa-solid fa-chevron-down',
        previous: 'fa-solid fa-chevron-left',
        next: 'fa-solid fa-chevron-right',
        today: 'fa-solid fa-screenshot',
        clear: 'fa-solid fa-trash',
        close: 'fa-solid fa-remove',
        inline: true
      }
    };
  }
}
